import useAccount from "./useAccount";

/**
 * Returns current contractor_id with a strong guarantee.
 * Intended for contractor-only modules like contractor panel.
 */
export const useContractorId = () => {
  const { account } = useAccount();
  const contractorId = account?.contractor_id;

  if (!contractorId) {
    throw new Error(
      "contractor_id is required in contractor-only modules context",
    );
  }

  return contractorId;
};
